import moment from 'moment';
import type { FighterAttributes, Sport } from './types';

export const inchesToFeet = (value: number) => {
	const feets = Math.floor(value / 12);
	const inches = value % 12;

	return `${feets}'${inches}"`;
};
export const dateOfBirthToAge = (date: string) => moment().diff(new Date(date), 'years');
export const sample = <T>(array: T[]): T => array[Math.floor(Math.random() * array.length)];

export function ensure<T>(
	argument: T | undefined | null,
	message = 'This value was promised to be there.'
): T {
	if (argument === undefined || argument === null) {
		throw new TypeError(message);
	}

	return argument;
}
export const toPercent = (value: number) => `${(value * 100).toPrecision(3)}%`;

export const getFighterRecord = (fighter: FighterAttributes, sport: Sport) => {
	return sport == 'MMA' ? fighter.professionalRecords.mma : fighter.professionalRecords.bkfc;
};
